module.exports = __webpack_public_path__ + "media/hats.c855f3bd.wav";